<template>
  <div class="col-12">
    <div class="col-sm-12 col-md-6 col-lg-4 offset-md-3 offset-lg-4">
      <el-card>
        <div slot="header" class="clearfix">
          <h3>Reset your password</h3>
        </div>
        <div class="d-flex justify-content-center" v-if="loading">
          <div class="loader w-100"></div>
        </div>
        <div v-else-if="error">
          <el-alert
            title="Error"
            :description="errorMessage"
            type="error"
            :closable="false"
            :show-icon="true"
          >
          </el-alert>
        </div>
        <div
          class="d-flex flex-column align-items-stretch"
          v-else-if="success"
        >
          <el-alert
            title="Verified"
            :description="successMessage"
            type="success"
            class="mb-2"
            :closable="false"
            :show-icon="true"
          >
          </el-alert>
          <el-form
            v-if="!resetSuccess"
            :model="passForm"
            status-icon
            :rules="rules"
            ref="passForm"
            class="passForm"
          >
            <el-form-item label="Enter new password" prop="pass">
              <el-input
                type="password"
                v-model="passForm.pass"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="Confirm new password" prop="checkPass">
              <el-input
                type="password"
                v-model="passForm.checkPass"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <div class="d-flex justify-content-center">
              <el-button
                type="primary"
                class="my-2"
                @click="resetPassword"
                :loading="resetLoading"
                >Confirm</el-button
              >
            </div>
          </el-form>
        </div>
      </el-card>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("Please enter a password"));
      } else if (value.length < 6) {
        callback(new Error("Please enter at least 6 characters"));
      } else {
        if (this.passForm.checkPass !== "") {
          this.$refs.passForm.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("Please confirm the password"));
      } else if (value !== this.passForm.pass) {
        callback(new Error("The passwords do not match"));
      } else {
        callback();
      }
    };
    return {
      userId: this.$route.query.id,
      token: this.$route.query.token,
      loading: true,
      passForm: {
        pass: "",
        checkPass: "",
      },
      rules: {
        pass: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }],
      },
      success: false,
      successMessage: null,
      resetSuccess: false,
      error: false,
      errorMessage: null,
      resetLoading: false,
    };
  },
  methods: {
    verifyUser() {
      let vm = this;
      vm.loading = true;
      vm.error = false;
      vm.errorMessage = null;
      vm.$http
        .post("reset/verify", {
          user_id: vm.userId,
          token: vm.token,
        })
        .then(
          () => {
            // success
            vm.error = false;
            vm.loading = false;
            vm.success = true;
            vm.successMessage =
              "Set up a new password for your ZipClippin account.";
          },
          (response) => {
            vm.success = false;
            vm.loading = false;
            vm.error = true;
            vm.errorMessage = response.body.non_field_errors[0];
          }
        );
    },
    resetPassword() {
      let vm = this;
      this.$refs["passForm"].validate((valid) => {
        if (valid) {
          vm.loading = true;
          vm.error = false;
          vm.errorMessage = null;
          vm.resetLoading = true;
          vm.$http
            .post("reset", {
              user_id: vm.userId,
              token: vm.token,
              password: vm.passForm.pass,
            })
            .then(
              () => {
                // success
                vm.resetSuccess = true;
                vm.error = false;
                vm.loading = false;
                vm.success = true;
                vm.successMessage =
                  "Password updated successfully. You can now log in using your new password.";
                vm.resetLoading = false;
              },
              (response) => {
                vm.success = false;
                vm.loading = false;
                vm.error = true;
                vm.resetSuccess = true;
                vm.errorMessage = response.body.non_field_errors[0];
                vm.resetLoading = false;
              }
            );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
  created() {
    let vm = this;
    if (!this.userId || !this.token) {
      vm.error = true;
      vm.errorMessage = "The link you followed isn't working.";
      vm.loading = false;
    } else {
      this.verifyUser();
      // vm.error = false;
      // vm.loading = false;
      // vm.success = true;
      // vm.successMessage = "Success";
    }
  },
};
</script>
<style lang="scss">
.loader {
  border: 8px solid #f3f3f3; /* Light grey */
  border-top: 8px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 1s linear infinite;
}

span.error:empty:before {
  content: "\200b"; // unicode zero width space character
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
